import axios from "axios";
import moment from "moment";

/**
 * @classdesc Un lien privilégié pour une inscription à un module
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class Lien_VIP
 */
export default class Lien_VIP {
    id;
    id_module;
    id_commande;
    token;
    nb_inscrits = 1;
    doit_payer_course = 1;
    filter_parcours = [];
    limit_acces_parcours = false;
    doit_payer_option = 1;
    acces_options_completes = 0;
    doit_payer_activite = 1;
    acces_activites_completes = 0;
    mail = "";
    for_billetterie = 0;
    date_creation = moment().format("YYYY-MM-DD HH:mm:ss");
    date_utilisation;
    date_expiration;
    actif = 1;

    /**
     * Creates an instance of Lien_VIP.
     * @constructs
     * @kind function
     * @memberof Lien_VIP
     */
    constructor() { }



    async fetch() {
        let res = await axios.get("/lien_vip/get.php?id_module=" + this.id_module + "&token=" + this.token);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.set(res.data);
            return await true;
        }
    }

    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }

    }

    build_filter_parcours(list) {
        this.filter_parcours = [];
        for (let i = 0; i < list.length; i++) {
            this.filter_parcours.push({
                id: list[i].id,
                nom: list[i].nom,
                selected: false
            });
        }
    }

    async post() {
        let res = await axios.post("/lien_vip/post.php", this);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

    async resend_email() {
        let res = await axios.get("/lien_vip/resend_email.php?id=" + this.id);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

    async remove() {
        let res = await axios.get("/lien_vip/delete.php?id=" + this.id);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

    async deactivate() {
        let res = await axios.get("/lien_vip/deactivate.php?id=" + this.id);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }
    async activate() {
        let res = await axios.get("/lien_vip/activate.php?id=" + this.id);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

    is_valid() {
        if (this.actif == 0) return false;
        if (this.date_expiration != '0000-00-00 00:00:00' && moment(this.date_expiration).endOf("day").isBefore(moment())) return false;
        if (this.date_utilisation != '0000-00-00 00:00:00') return false;
        return true;
    }

    get_status() {
        if (this.actif == 0) {
            return "Malheureusement ce code n'est plus valide, il a été désactivé.";
        }
        if (this.date_expiration != '0000-00-00 00:00:00' && moment(this.date_expiration).endOf("day").isBefore(moment())) {
            return "Malheureusement ce code n'est plus valide, il a expiré le " + moment(this.date_expiration).format("DD/MM/YYYY") + ".";
        }
        if (this.date_utilisation != '0000-00-00 00:00:00') {
            return "Malheureusement ce code n'est plus valide, il a été utilisé le " + moment(this.date_utilisation).format("DD/MM/YYYY") + ".";
        }
        let response = "";
        if (this.nb_inscrits) {
            response += "Ce code permet l'inscription de " + this.nb_inscrits + " personne(s).";
        }
        if (this.limit_acces_parcours == "1") {
            response += " L'inscription aux parcours est limité à la séléction définie par l'organisateur ";
            let selection = "(";
            selection += this.filter_parcours
                .filter((course) => course.selected)
                .map((course) => course.nom)
                .join(", ");
            selection += ").";
            response += selection;
        }
        if (this.doit_payer_course == "0") {
            response += " L'inscription aux parcours est gratuite.";
        }

        if (this.doit_payer_option == "0") {
            response += " L'inscription aux options est gratuite.";
        }
        if (this.acces_options_completes == "1") {
            response += " L'inscription aux options complètes est autorisée.";
        }
        if (this.doit_payer_activite == "0") {
            response += " L'inscription aux activités est gratuite.";
        }
        if (this.acces_activites_completes == "1") {
            response += " L'inscription aux activités complètes est autorisée.";
        }

        return response;

    }
}